import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    question: {
        composes: "question",
        position: "relative",
        margin: ({ theme }) => [[theme.QuestionSpacing, -29]],
        padding: [[0, 29]],
        "& img, video, iframe": {
            maxWidth: "100%",
        },
    },
    questionLegend: {
        composes: "question__legend",

        /* Set width of <legend> encapsulating the question label to fix text-wrapping of long questions in IE11 */
        width: "100%",
    },
    questionName: {
        composes: "question__name",
        lineHeight: `inherit`,
        marginTop: 29,
        marginBottom: 14.5,
    },
    questionTitle: {
        composes: "question__title",
    },
    questionText: {
        composes: "question__text",
        display: "block",
        textAlign: ({ theme }) => Mixins.getTextAlign(theme.TextTextAlign),
        wordWrap: "break-word",
        marginBottom: "0.5em",
    },
    questionContent: {
        composes: "question__content",
        marginTop: 29,
    },
    questionShortText: {
        composes: "question__short-text",
    },
    questionError: {
        composes: "question--error",
    },
    questionValidation: {
        alignItems: "center",
        composes: "question__validation",
        display: "inline-flex",
    },
    questionValidationFocus: {
        borderLeftColor: ({ theme }) => theme.ErrorColor,
        composes: "question__validation-focus",
    },
    dynamicQuestionValidationFocus: {
        borderLeftStyle: "solid",
        borderLeftWidth: 3,
        left: -30,
        paddingLeft: 30,
        position: "relative",
        width: "100%",
    },
});
